<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <h4 class="DuzenlemeModu">Düzenleme Modu
      <el-button size="mini" type="danger" @click="DuzenlemeyiKaydet" class="pull-right">Düzenlemeyi Kaydet</el-button>
    </h4>
    <hot-table licenseKey="non-commercial-and-evaluation"
               width="100%"
               height="83vh"
               :colHeaders="['Bina Adı','Durum','Sorumlu','Bölge','Aciklama','Okuma Gün','Okuma Türü','Tahsilat','Fatura','Koordinat','İlgili','Telefon','Referans','Bina Yönetimi','Sayaç Yıl','Sayaç Marka','Okuma Bilgi','Email']"
               :columnSorting='true'
               :columns="[
                          {data: 'Adi',editor: false,width:'300'},
                          {data: 'Durum',editor: 'numeric',width:'100'},
                          {data: 'Sorumlu',width:'100',editor: 'select',selectOptions: ['Ekip 1','Ekip 2','Ekip 3','Ekip 4','Ekip 5']},
                          {data: 'oBolge',width:'100',editor: 'select',
                          selectOptions:['Ambar','Altınoluk','Argıncık','Belsin','Beyazşehir','Talas Mevlana 1','Talas Mevlana 2','Talas Bahçelievler','Talas Yenidoğan','Mimsin','Mimsin Toki','Gökkent','Serkent','İldem','Esentepe','Erkilet','Mithatpaşa','Esenyurt','Hurriyet','Köşk','Kazım Karabekir','Küçükali','Konaklar','Zümrüt','Ziyagökalp','Uğurevler','Yıldırım Beyazıt','Sümer','Yakut','Merkez','İlçeler','Nevşehir','Niğde','Yozgat','Kırşehir']
                          },
                          {data: 'Aciklama',editor: 'numeric',width:'100'},
                          {data: 'oGun',editor: 'numeric',width:'100'},
                          {data: 'Tur',width:'100',editor: 'select',selectOptions: ['Fiziksel','Uzaktan','Mad RF','Daf RF','Qundis RF','Beyaz Anten RF']},
                          {data: 'TahsilUcreti',editor: 'text',width:'70'},
                          {data: 'OkumaUcreti',editor: 'text',width:'70'},
                          {data: 'Koordinat',editor: 'text',width:'100'},
                          {data: 'Ilgili',editor: 'text',width:'150'},
                          {data: 'Iletisim',editor: 'text',width:'100'},
                          {data: 'Referans',editor: 'numeric',width:'70'},
                          {data: 'Yonetim',editor: 'numeric',width:'100'},
                          {data: 'SayacYil',editor: 'numeric',width:'70'},
                          {data: 'SayacMarka',editor: 'numeric',width:'100'},
                          {data: 'OkumaYeri',editor: 'numeric',width:'300'},
                          {data: 'Email',editor: 'text',width:'300'},

                      ]"
               :data="data" v-if="data"></hot-table>
  </div>
</template>

<script>
import {HotTable} from '@handsontable/vue';
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  props: ['data'],
  components: {Yukleniyor, HotTable},
  data() {
    return {
      lo: false
    }
  },
  methods: {
    DuzenlemeyiKaydet() {
      this.$confirm("Toplu güncelleme yapılacaktır. Lütfen onaylayınız.", "Güncelleme Onayı", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.DuzenlemeyiGonder();
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    DuzenlemeyiGonder() {
      this.lo = true;
      this.$store.dispatch("Post", {Data: this.data, path: '_enerji/topluduzenleme/'})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    }
  }
}
</script>

<style scoped>
@import '~handsontable/dist/handsontable.full.css';

.DuzenlemeModu {
  color: red;
  border-bottom: 1px solid #ccc;
  margin-top: -10px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Bina/DuzenlemeTable.vue